// Billing module routes — UPDATED for Epic FE-US-INT-01 §6 Phase 4.
//
// Renames:
//   InvoicesListPage  → BillsListPage   ("history coming soon" empty state)
//   InvoiceDetailPage → BillDetailPage  (latest bill when accountUid in path)
//
// Path conventions:
//   /billing                 — dashboard (read latest bill via ?accountUid=)
//   /billing/bills           — tenant-wide bill-cycle worklist (BillsPage);
//                              ?accountUid= → that account's bill history
//   /billing/bills/:billRef  — bill detail (accountUid → latest bill,
//                              otherwise "coming soon")
//   /billing/settings        — tenant-wide Bill Settings (BillSettingsPanel)
//
// The legacy `/billing/invoices(/:invoiceId)?` paths are intentionally
// dropped — nothing in the FE links to them after rewire.

import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const BillingDashboardPage = lazy(() =>
  import('./pages/BillingDashboardPage').then((m) => ({ default: m.BillingDashboardPage })),
);
const BillsPage = lazy(() =>
  import('./pages/BillsPage').then((m) => ({ default: m.BillsPage })),
);
const BillDetailPage = lazy(() =>
  import('./pages/BillDetailPage').then((m) => ({ default: m.BillDetailPage })),
);
const BillingSettingsPage = lazy(() =>
  import('./pages/BillingSettingsPage').then((m) => ({ default: m.BillingSettingsPage })),
);
const BillingExceptionsPage = lazy(() =>
  import('./pages/BillingExceptionsPage').then((m) => ({
    default: m.BillingExceptionsPage,
  })),
);

export const billingRoutes: RouteObject[] = [
  { path: '/billing', element: <BillingDashboardPage /> },
  { path: '/billing/bills', element: <BillsPage /> },
  { path: '/billing/bills/:billRef', element: <BillDetailPage /> },
  { path: '/billing/settings', element: <BillingSettingsPage /> },
  // F3/F5 — tenant-wide exception-check config + dismissed audit log. The `/log`
  // variant renders the same page but pre-selects the Dismissed-log tab.
  { path: '/billing/exceptions', element: <BillingExceptionsPage /> },
  { path: '/billing/exceptions/log', element: <BillingExceptionsPage /> },
];
